var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarrot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.063 16.72a9 9 0 0 0-2.47.5c-16.076 5.625-27.55 10.77-36.155 21.81-6.477 8.313-10.984 18.854-16.063 34.407-11.313-12.292-26.732-22.486-43.875-30.812-23.817-11.568-51.083-19.46-76.156-22.78a9 9 0 0 0-6.282 16.343c21.685 14.934 40.525 29.268 53.407 43.687 9.964 11.155 16.21 22.01 18.436 33.53-32.89-3.705-62.75 3.47-99.406 23.25a9 9 0 0 0 5.125 16.907c34.352-3.265 69.484-3.808 96.563.625 13.54 2.217 25.007 5.723 33.218 10.25 3.168 1.747 5.82 3.57 8 5.532 5.365-8.13 12.033-15.638 19.438-22.22 13.09-11.637 28.792-20.638 45.03-24.094-11.326-18.24-14.138-30.23-12.843-41.5 1.588-13.813 10.567-28.893 22.564-52.344a9 9 0 0 0-8.53-13.093zm13.906 123.436c-.527-.003-1.062.016-1.595.03-14.925.428-32.515 8.518-46.594 21.033-16.088 14.3-26.977 33.817-26.78 50 .39 32.175 18.688 67.77 47.344 102.124 28.655 34.354 67.3 67.31 106.375 94.72 39.073 27.406 78.66 49.316 108.78 61.936 15.06 6.31 27.857 10.275 36.313 11.5 3.958.574 6.797.448 8.187.188.065-.798.153-1.837.063-3.22-.205-3.113-.814-7.504-1.844-12.75-2.06-10.49-5.772-24.554-10.97-40.812-10.397-32.516-26.75-73.9-47.688-114.937-13.56-26.58-29.085-53.016-46.093-76.814-14.193 17.317-12.034 17.985-49.72 36.72l-7.125-14.313c39.43-19.6 30.222-15.247 47.063-35.594-6.235-8.066-12.65-15.74-19.22-22.907a286.281 286.281 0 0 0-9.937-10.344c-24.116 33.382-44.493 41.374-76.436 55.124l-7.125-16.53c32.963-14.19 47.585-18.322 70.218-50.814-21.94-18.66-45.057-30.964-68.594-34.03a37.434 37.434 0 0 0-4.625-.314z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrot);
export default __webpack_public_path__ + "static/media/carrot.e99953b6a8a9e7abd272ba3ac6185f10.svg";
export { ForwardRef as ReactComponent };